import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface CustomerSupplierType {
    active: number;
    createdAt: any;
    description: string;
    name: string;
    type: string;
    updatedAt: any;
}

interface CustomerSupplierTypeId extends CustomerSupplierType {
    id: string;
}

@Injectable()
export class CustomerSupplierTypeService {

    customerSupplierTypeCollection: AngularFirestoreCollection<CustomerSupplierType>;
    customerSupplierTypes: any;

    customerSupplierTypeDocument: AngularFirestoreDocument<CustomerSupplierTypeId>;
    customerSupplierType: Observable<CustomerSupplierTypeId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.CUSTOMER_SUPPLIER_TYPE_COLLECTION;
    }

    postCustomerSupplierType(customerSupplierTypeObject: any) {
        this.customerSupplierTypeCollection = this.afs.collection(this.collection);

        return this.customerSupplierTypeCollection.add(customerSupplierTypeObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    postCustomerSupplierTypeWithId(customerSupplierTypeObject: any, id$: string) {
        this.customerSupplierTypeCollection = this.afs.collection(this.collection);

        return this.customerSupplierTypeCollection.doc(id$).set(customerSupplierTypeObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getCustomerTypes() {
        this.customerSupplierTypeCollection = this.afs.collection(this.collection, ref => ref.where('type', '==', 'C'));

        this.customerSupplierTypes = this.customerSupplierTypeCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as CustomerSupplierType;

                const name = data.name;
                const description = data.description;

                return { id$, name, description };
            });
        }).map(object => object);

        return this.customerSupplierTypes;
    }

    getCustomerSupplierType(id$: string) {
        this.customerSupplierTypeDocument = this.afs.doc(this.collection + '/' + id$);

        this.customerSupplierType = this.customerSupplierTypeDocument.valueChanges();

        return this.customerSupplierType.map(object => object);
    }

    putCustomerSupplierType(customerSupplierTypeObject: any, id$: string) {
        this.customerSupplierTypeCollection = this.afs.collection(this.collection);

        return this.customerSupplierTypeCollection.doc(id$).update(customerSupplierTypeObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delCustomerSupplierType(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.customerSupplierTypeDocument = this.afs.doc(this.collection + '/' + id$);

        return this.customerSupplierTypeDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

}
